import {
  eventBus
} from '../eventbus'

export default {
  data: function () {
    return {
      help: false,
      //helpers object starts empty
      helpers: {}
    }
  },
  watch: {
    help: function () {
      if (!this.help) {
        this.hideEvery(true);
      }
    }
  },
  methods: {
    subscribe: function (name) {
      this.helpers[name] = false;
    },
    hideEvery: function (showNone, except) {
      for (var prop in this.helpers) {
        if (prop != except) {
          this.helpers[prop] = false;
        }
      }
      if (showNone) {
        eventBus.$emit("toggleHelper", "")
      }
    },
    trigger_help: function (name) {
      this.hideEvery(false, name);
      if (this.help) {
        this.helpers[name] = !this.helpers[name];
      }
      eventBus.$emit("toggleHelper", name)
      //ritorna lo stato del popover
      return this.helpers[name]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/help_mode_handler_mixin.js